import { render, staticRenderFns } from "./ImageFeaturedNoImage.vue?vue&type=template&id=1de1cb15"
import script from "./ImageFeaturedNoImage.vue?vue&type=script&lang=js"
export * from "./ImageFeaturedNoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports